/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useState } from "react";
import { geolocated } from "react-geolocated";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCrosshairs } from "@fortawesome/free-solid-svg-icons";
import { Button, Tooltip } from "antd";
import { getApiHost } from "../../../utils";
import Axios from "axios";
import { TI_MAP_CURRENT_LOCATION_BUTTON } from "../../../Constants";

const WidgetGeolocated = ({
  isGeolocationAvailable,
  isGeolocationEnabled,
  coords,
  positionError,
  onClick,
  style,
}) => {
  const [address, setAddress] = useState();
  const isSpin = isGeolocationEnabled && !coords;
  const iconColor = !isGeolocationEnabled
    ? "gray"
    : positionError
    ? "red"
    : "green";
  /*
  useEffect(() => {

  }, [coords]);
*/
  const onButtonClick = useCallback(() => {
    if (coords && onClick) {
      if (coords) {
        const { latitude, longitude } = coords;

        const url = getApiHost() + "/address/getEmdKorNm.json";
        const params = { lat: latitude, lon: longitude };

        positionError = false;

        Axios.get(url, { params })
          .then(({ data }) => {
            const { EMD_KOR_NM } = data;
            setAddress(EMD_KOR_NM);
            positionError = true;
          })
          .catch((reason) => {
            console.error(reason);
          })
          .finally(() => {
            positionError = false;
          });
        onClick({ latitude, longitude });
      }
    }
  }, [coords, onClick]);

  let tooltip;
  if (!isGeolocationAvailable)
    tooltip = "현재 위치 찾기 기능을 활성화시켜주세요.";
  if (address) tooltip = `현재 위치로 이동`;
  else if (!positionError) tooltip = "현재 위치 찾는 중 ...";
  else tooltip = "현재 위치 찾기 실패";

  return (
    <div style={style}>
      <Tooltip title={tooltip} placement="left">
        <Button
          shape={"circle"}
          onClick={onButtonClick}
          aria-label={tooltip}
          tabIndex={TI_MAP_CURRENT_LOCATION_BUTTON}
        >
          <FontAwesomeIcon
            icon={faCrosshairs}
            spin={isSpin}
            color={iconColor}
          />
        </Button>
      </Tooltip>
    </div>
  );
};

const GEOLOCATED_CONFIG = {
  positionOptions: {
    enableHighAccuracy: false,
  },
  userDecisionTimeout: 5000,
};

export default geolocated(GEOLOCATED_CONFIG)(WidgetGeolocated);
